import { useEffect, useState } from 'react';
import { getConfig } from '../utils/get-config';

export function useGooglePaySupport() {
  const [supportsGooglePay, setSupportsGooglePay] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      console.log('[GooglePay] window undefined (SSR)');
      return;
    }

    console.log('[GooglePay] Starting support check');

    try {
      const w = window as any;

      const hasPaymentRequest =
        w.PaymentRequest && typeof w.PaymentRequest === 'function';

      console.log('[GooglePay] PaymentRequest available:', hasPaymentRequest);

      if (hasPaymentRequest) {
        console.log('[GooglePay] Creating PaymentRequest instance');

        const pr = new w.PaymentRequest(
          [{ supportedMethods: 'https://google.com/pay' }],
          { total: { label: 'Test', amount: { value: '0', currency: 'USD' } } },
        );

        console.log('[GooglePay] Calling canMakePayment()');

        if (getConfig('REACT_APP_SHOW_WALLETS') == 'true') {
          setSupportsGooglePay(true);
          return;
        }
        pr.canMakePayment()
          .then((result: any) => {
            console.log('[GooglePay] canMakePayment result:', result);

            setSupportsGooglePay(!!result);
            setChecked(true);

            if (result) {
              console.log('[GooglePay] ✅ Google Pay supported');
            } else {
              console.log('[GooglePay] ❌ Google Pay NOT supported');
            }
          })
          .catch((err: any) => {
            console.error('[GooglePay] canMakePayment error:', err);

            setSupportsGooglePay(false);
            setChecked(true);
          });
      } else {
        console.warn(
          '[GooglePay] PaymentRequest API not available in this browser',
        );

        setSupportsGooglePay(false);
        setChecked(true);
      }
    } catch (e) {
      console.error('[GooglePay] Unexpected error during check:', e);

      setSupportsGooglePay(false);
      setChecked(true);
    }
  }, []);

  return { supportsGooglePay, checked };
}